import { reducer as reduxFormReducer } from "redux-form";
import flashMessages from "./reducers/flashMessages";

import poll from "./reducers/poll";
import { POLL_PROPERLY_SAVED } from "./actions/types";
import PollConfig from "./utils/PollConfig";

export default {
  flashMessages,
  poll,
  form: reduxFormReducer.plugin({
    pollForm: (state, action) => {
      switch (action.type) {
        case POLL_PROPERLY_SAVED:
          if (action.clear) {
            const config = new PollConfig();
            return { values: config.initialValues(), initial: config.initialValues() }; // <--- blow away form data
          }
          return state;

        default:
          return state;
      }
    }
  })
};



// WEBPACK FOOTER //
// ./src/reducers.js